"use client";
import { cn } from "@/lib/utils";
import Link, { LinkProps } from "next/link";
import React, { useState, createContext, useContext, useEffect } from "react";
// import { AnimatePresence, motion } from "motion/react";
import { AnimatePresence, motion, MotionValue } from "framer-motion";
import { IconMenu2, IconMenu4, IconMenuDeep, IconX } from "@tabler/icons-react";
import useGlobalStore from "@/stores/global-store";
import classNames from "classnames";
// import { LinkPreviewDemo } from "./demos/LinkPreviewDemo";
import { ButtonsGroup, PlaneIcon } from "./demos/AnimatedModalDemo";
import { DefaultNavLink, medialinks, NavLink, navLinkNull, navlinks, toollinks } from "@/app/(work)/layout-left/main-sidebar";
import { useDebouncedCallback } from "use-debounce";
import clsx from "clsx";
import { VisibilitySelector } from "../visibility-selector";
import { ChatFlowNavSelector } from "../custom/chat-flow-nav-selector";

interface Links {
  label: string;
  href: string;
  icon?: React.JSX.Element | React.ReactNode;
  isActive?: boolean;
}

interface SidebarContextProps {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  animate: boolean;
  path: string;
  setPath: React.Dispatch<React.SetStateAction<string>>;
}

const SidebarContext = createContext<SidebarContextProps | undefined>(
  undefined
);

export const useSidebar = () => {
  const context = useContext(SidebarContext);
  if (!context) {
    throw new Error("useSidebar must be used within a SidebarProvider");
  }
  return context;
};

export const SidebarProvider = ({
  children,
  open: openProp,
  setOpen: setOpenProp,
  animate = true,
  path: pathProp,
  setPath: setPathProp,
}: {
  children: React.ReactNode;
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  animate?: boolean;
  path?: string;
  setPath?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const [openState, setOpenState] = useState(false);
  const [pathState, setPathState] = useState<string>('');
  const open = openProp !== undefined ? openProp : openState;
  const setOpen = setOpenProp !== undefined ? setOpenProp : setOpenState;
  const path = pathProp !== undefined ? pathProp : pathState;
  const setPath = setPathProp !== undefined ? setPathProp : setPathState;

  return (
    <SidebarContext.Provider value={{ open, setOpen, path, setPath, animate: animate }}>
      {children}
    </SidebarContext.Provider>
  );
};

export const Sidebar = ({
  children,
  open,
  setOpen,
  animate,
  path,
  setPath,
}: {
  children: React.ReactNode;
  open?: boolean;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  animate?: boolean;
  path?: string;
  setPath?: React.Dispatch<React.SetStateAction<string>>;
}) => {
  return (
    <SidebarProvider open={open} setOpen={setOpen} animate={animate} path={path} setPath={setPath}>
      {children}
    </SidebarProvider>
  );
};

export const SidebarBody = (props: React.ComponentProps<typeof motion.div>) => {
  return (
    <>
      <DesktopSidebar {...props} />
      {/* <MobileSidebar {...(props as React.ComponentProps<"div">)} />  手机屏幕不显示 第一级别侧栏菜单*/}
    </>
  );
};

// export const MobileSidebar2 = ({
//   themeColor = '#ffffff',
//   onClose,
//   onSelect,
//   customClassName,
//   className,
//   children,
//   ...props
// }: React.ComponentProps<"div"> & MobileSidebar2Props) 

interface CustomSidebarBodyProps {
  onSelect?: (link:any) => void;
}

export const DesktopSidebar = ({
  className,
  children,
  ...props
}: React.ComponentProps<typeof motion.div>) => {
  const { open, setOpen, animate, path } = useSidebar();
  // limk.mark: 移除动效
  // const animate= false; 
  // const open =false;

  // const { llog } = useGlobalStore();
  //   useEffect(() => {
  //     llog('limk.log tool DesktopSidebar path:' + path);
  //   }, [path]);

  return (
    <>
      <motion.div
        // className={cn(
        //   "h-full px-4 py-4 hidden md:flex md:flex-col bg-neutral-100 dark:bg-neutral-800 w-[300px] shrink-0",
        //   className
        // )}
        className={cn(
          "!hidden md:!flex", // 强制移动端隐藏
          `h-full pl-4 py-4 md:flex md:flex-col bg-neutral-100 dark:bg-neutral-800 w-[300px] shrink-0`,
          className
        )}
        style={{ display: undefined }} // 清除默认 display
        animate={{
          // width: animate ? (open ? "300px" : "60px") : "300px",
          // width: animate ? (open ? "250px" : "60px") : "250px",
          width: animate ? (open ? "160px" : "160px") : "160px", // // limk.mark: 移除动效

          right: 0,
          // width: path === "#history" ? (animate ? (open ? "220px" : "60px") : "220px" ) : (animate ? (open ? "220px" : "30px") : "220px"),
        }}
        // limk.mark: 移除动效
        // onMouseEnter={() => setOpen(true)}
        // onMouseLeave={() => setOpen(false)}
        {...props}
      >
        {children}
      </motion.div>
    </>
  );
};


export const MobileSidebar = ({
  className,
  children,
  ...props
}: React.ComponentProps<"div">) => {
  const { open, setOpen } = useSidebar();
  // console.log('MobileSidebar1 isOepn:', open);

  return (
    <>
      <div
        className={cn(
          "h-10 px-4 py-0 flex flex-row md:hidden  items-center justify-between bg-neutral-100 dark:bg-neutral-800 w-full"
        )}
        {...props}
      >
        <div className="absolute w-[40px] top-4 right-2 flex justify-end z-20">
          <div className="z-28 w-full  bg-white-500">
          </div>
          <IconMenuDeep
            className="text-neutral-800 w-[60px]  dark:text-neutral-200"
            onClick={() => setOpen(!open)}
          />
        </div>
        <AnimatePresence>
          {open && (
            <motion.div
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{
                duration: 0.3,
                ease: "easeInOut",
              }}
              className={cn(
                "fixed h-full w-full inset-0 bg-white dark:bg-neutral-900 p-10 z-[100] flex flex-col justify-between",
                className
              )}
            >
              <div
                className="absolute right-16 top-10 z-50 text-neutral-800 dark:text-neutral-200"
                onClick={() => setOpen(!open)}
              >
                <IconX  />
              </div>
              {children}
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};


// 类型定义调整
type SidebarBody2Props = Omit<React.ComponentProps<typeof motion.div>, 'children'> & {
  children: React.ReactNode;
  onSelect?: (link: any) => void;
  desktopClassName?: string;
  mobileClassName?: string;
};

export const SidebarBody2 = ({
    onSelect,
    children,
    className: bodyClassName,
    desktopClassName,
    mobileClassName,
    ...props
  }: SidebarBody2Props) => {
    // console.log('SidebarBody2 children:', children); //
  // 过滤掉motion特有的属性
  const mobileProps = Object.fromEntries(
    Object.entries(props).filter(([key]) => !['animate', 'transition', 'variants'].includes(key))
  );
  return (
    <>
      {/* <DesktopSidebar2 {...props} /> */}
      {/* <MobileSidebar2 {...(props as React.ComponentProps<"div">)} onSelect={onSelect}  /> */}
      <>
      <DesktopSidebar2 
        {...props} 
        className={clsx(bodyClassName, desktopClassName)}
        onSelect={onSelect}
      >
        {children}
      </DesktopSidebar2>
      <MobileSidebar2
         {...mobileProps}

        className={clsx(bodyClassName, mobileClassName)}
        onSelect={onSelect}
      >
        {children}
      </MobileSidebar2>
    </>
    </>
  );
};

// Mobile组件props类型调整
interface DesktopSidebar2Props extends React.ComponentProps<typeof motion.div> {
  themeColor?: string;
  onClose?: () => void;
  onSelect?: (link: any) => void;
  children: React.ReactNode; // 显式声明children类型
}

export const DesktopSidebar2 = ({
  className,
  children,
  ...props
}: React.ComponentProps<typeof motion.div>) => {

// export const DesktopSidebar2 = ({
//   themeColor = '#fff',
//   className,
//   children,
//   ...props
// }: DesktopSidebar2Props) => {
  const { open, setOpen, animate, path } = useSidebar();

  // const { llog } = useGlobalStore();

  //   useEffect(() => {
  //     llog('limk.log tool DesktopSidebar path:' + path);
  //   }, [path]);


  /** 问题原因分析
    代码中 motion.div 未在移动端隐藏的根本原因是 Tailwind 响应式断点逻辑冲突，结合代码结构分析具体原因如下：
    断点逻辑冲突
    className="hidden md:flex" 
    实际生效逻辑：在 md 断点（≥768px）显示为 flex，在 <768px 时显示为 hidden
    预期行为：在移动端隐藏 ✅ 看似配置正确，但实际未生效
    父容器干扰
    // 父容器
    <div className="flex flex-col md:flex-row">
      <motion.div className="hidden md:flex" />
    </div>
    父容器的 md:flex-row 会强制子元素在 ≥768px 时变为横向布局

    可能干扰子元素的 display 属性继承

    Motion 组件特性
    Framer Motion 的 motion.div 默认会添加 display: block 内联样式
    与 Tailwind 的 hidden 类产生冲突（hidden → display: none）

    扩展建议
    Tailwind 调试技巧
    bash
    npm install -D tailwindcss-debug-screens

    <div className="debug-screens">...</div>
    在页面右下角显示当前激活的断点

    Motion 高级控制
    <motion.div
      animate={{
        display: ["none", "flex"] // 直接控制 display 属性
      }}
    />

   */

  // NextJS组件高度自适应布局调整: https://chat.deepseek.com/a/chat/s/2b773c06-1740-4211-8ca1-e92f1c79179b
  return (
    <AnimatePresence>
      <div
          // className={cn(
          //   "!hidden md:!flex", // 强制移动端隐藏
          //   `h-full px-0 py-0 md:flex md:flex-col bg-neutral-100/90 dark:bg-neutral-800 w-[200px] shrink-0`,
          //   className
          // )}

          className={cn(
            "!hidden md:!flex", // 强制移动端隐藏
            `flex  h-screen px-0 py-0 md:flex md:flex-col w-[200px] shrink-0 bg-background`,
            className
          )}
      >
        <div
          className={cn(
            `px-0 p-2 w-[200px]   `, // https://www.tongyi.com/?sessionId=2d67a6370ac2452d8db57270969b6962
          )}
        >
          <ChatFlowNavSelector onSelect={props.onSelect} className="group/modal-btn flexShrink: 0" chatId={""}/>
          <SideBarButtonsGroup onSelect={props.onSelect} className="group/modal-btn flexShrink: 0"/>
        </div>
        <motion.div
          // className={cn(
          //   "h-full px-4 py-4 hidden md:flex md:flex-col bg-neutral-100 dark:bg-neutral-800 w-[300px] shrink-0 bg-red-100 dark:bg-red-100/10",
          //   className
          // )
          // className={cn(
          //   "!hidden md:!flex", // 强制移动端隐藏
          //   `h-[90vh] px-0  py-6 md:flex md:flex-col bg-neutral-100 dark:bg-neutral-800 w-[200px] shrink-0 bg-neutral-100 `,
          //   className
          // )}

          className={cn(
            "!hidden md:!flex", // 强制移动端隐藏
            `px-0  py-0  md:flex-1 md:flex-col flex-1 w-[200px] shrink-0  `, // https://www.tongyi.com/?sessionId=2d67a6370ac2452d8db57270969b6962
            className
          )}

          style={{ display: undefined }} // 清除默认 display
          animate={{
            // width: animate ? (open ? "300px" : "60px") : "300px",
            // width: animate ? (open ? "200px" : "0px") : "200px",
            // right: 40,
            width: path === "#history" ? (animate ? (open ? "220px" : "60px") : "220px" ) : (animate ? (open ? "220px" : "30px") : "220px"),
          }}
          // onMouseEnter={() => setOpen(true)}
          // onMouseLeave={() => setOpen(false)}
          {...props}
        >
          {children}
        </motion.div>
      </div>
    </AnimatePresence>
  );
};

// Mobile组件
// interface MobileSidebar2Props extends React.ComponentProps<"div"> {
//   themeColor?: string;
//   onClose?: () => void;
//   onSelect?: (link: any) => void;
// }

// Mobile组件props类型调整
interface MobileSidebar2Props extends React.ComponentPropsWithoutRef<'div'> {
  themeColor?: string;
  onClose?: () => void;
  onSelect?: (link: any) => void;
  children: React.ReactNode; // 显式声明children类型
}

export const MobileSidebar2 = ({
  themeColor = '#fff',
  className,
  children,
  ...props
}: MobileSidebar2Props) => {
  const { open, setOpen } = useSidebar();
  // console.log('MobileSidebar2 children:', children);

  return (
    <>
      <div
        className={cn(
          "h-10 px-4 py-0 flex flex-row md:hidden  items-center justify-between bg-neutral-100 dark:bg-neutral-800 w-full"
        )}
        {...props}
      >
        <div className="absolute top-4 left-4  flex w-[40px]  justify-end z-20">
          <div className="z-28 w-[40px] left-3 text-white bg-background">
          <IconMenu2
            className="text-neutral-800 dark:text-neutral-200"
            onClick={() => setOpen(!open)}
          />
          </div>
        </div>
        <AnimatePresence>
          {open && (<>
            <motion.div
              initial={{ x: "-100%", opacity: 0 }}
              animate={{ x: 0, opacity: 1 }}
              exit={{ x: "-100%", opacity: 0 }}
              transition={{
                duration: 0.3,
                ease: "easeInOut",
              }}
              className={cn(
                "fixed h-full w-full inset-0 bg-background dark:bg-neutral-900 px-10 pb-8 pt-8 z-[100] flex flex-col justify-between",
                className
              )}
            >
              <IconMenu2
                className="text-neutral-800 dark:text-neutral-200"
                onClick={() => setOpen(!open)}
              />
              <div
                className="absolute right-10 top-24 z-90 text-neutral-800 dark:text-neutral-200"
                onClick={() => setOpen(!open)}
              >
                <IconX />
              </div>
              <div
                className="absolute right-6 top-34 z-50 text-neutral-800 dark:text-neutral-200"
                onClick={() => setOpen(!open)}
              >
                <IconX />
              </div>
              <SideBarButtonsGroupMobile onSelect={props.onSelect} className="group/modal-btn"/>
              {children}
              <IconMenu2
                className="text-neutral-800 mb-0 dark:text-neutral-200"
                onClick={() => setOpen(!open)}
              />
            </motion.div>
            </>
          )}
        </AnimatePresence>
      </div>
    </>
  );
};

export const SidebarLink = ({
  link,
  className,
  ...props
}: {
  link: Links;
  className?: string;
  props?: LinkProps;
}) => {
  const { open, animate } = useSidebar();
  return (
    <Link
      href={link.href}
      className={cn(
        "flex items-center justify-start gap-0  group/sidebar py-0 bg-backgroud-500",
        className
      )}
      {...props}
    >
      {link.icon}

      <motion.span
        onClick={() => {
          // console.log("click");
        }}
        animate={{
          // display: animate ? (open ? "inline-block" : "none") : "inline-block",
          // opacity: animate ? (open ? 1 : 0) : 1,
        }}
        className="text-neutral-700 dark:text-neutral-200 text-sm group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0 bg-backgroud-500"
      >
        {link.label}
      </motion.span>
    </Link>
  );
};


export const SidebarLinkNoHref = ({
  link,
  className,
  ...props
}: {
  link: Links;
  className?: string;
  props?: LinkProps;
}) => {
  // const { open, animate } = useSidebar();
  return (
    <div
      // href={''}
      className={cn(
        "flex items-center justify-start gap-0 px-0 group/sidebar  cursor-pointer hover:underline",
        className
      )}
      {...props}
    >
      {/* <div className={`hover:text-foreground/80 ${link.isActive? 'text-orange-500' : ''} `}>{link.icon}</div> */}

      {link.isActive && <div className={`hover:text-foreground/80 ${link.isActive? 'text-orange-500' : ''} `}>{link.icon}</div> }

      <motion.span
        onClick={() => {
          // console.log("click");
        }}
        animate={{
          // display: animate ? (open ? "inline-block" : "none") : "inline-block",
          // opacity: animate ? (open ? 1 : 0) : 1,
        }}
        // className="text-neutral-700 dark:text-neutral-200 text-sm group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0 rounded bg-gradient-to-r from-backgroud-300/30 to-purple-300/30"

        // className="text-neutral-700 dark:text-neutral-200 text-sm font-normal"

        className={cn(
          link.isActive ? 
           "text-neutral-700 dark:text-neutral-200 text-sm group-hover/sidebar:translate-x-1 transition duration-150 whitespace-pre inline-block !p-0 !m-0 rounded bg-gradient-to-r from-backgroud-300/30 to-purple-300/30"
           : "flex items-center justify-start gap-1  group/sidebar px-1 cursor-pointer hover:underline",
        )}

      >
        {link.label}
      </motion.span>
    </div>
  );
};

export const SideBarButtonsGroup = ({onSelect, className }: {onSelect?: (link:any) => void; className?: string }) => {
  // const { setOpen } = useModal();
  // const debouncedMoauseOver = useDebouncedCallback(async (value: string) => {
  //   // llog(`side bar useDebouncedCallback:${value}`);
  //   // setMouseOverPath(value);
  //   // setOpen(false);
  //   // setAnimate(true);
  // }, 300);

  // const debounceSelect = useDebouncedCallback(async (value: string) => {
  //   console.log(`side bar useDebouncedCallback:${value}`);
  //   setSelectedPath(value)
  //   setOpen(false);
  //   ;
  // }, 300);

  const [currentLink, setCurrentLink] = useState<NavLink>(DefaultNavLink);

  const handleSelect=(link:NavLink)=>{
    console.log('sidebar-handleSelect:' + link.href.slice(1) );
    console.log('sidebar-handleSelect: link', link );

    setCurrentLink(link);
    onSelect && onSelect(link);

    // setSpaceTag(link.href.slice(1));
    // debounceSelect(link.href);
  }

  // const activeCss = 'text-orange-500 border-border border-2 dark:text-orange-500 border-border border-1'
    const activeCss  =  'text-orange-700/80 dark:text-orange-400 border-b border-1 border-orange-700/80 dark:border-orange-400'
    const activeCss1 = 'text-orange-700/80 dark:text-orange-400 border-b border-radius-10% border-1'

  return (
    <div className={className}>
        {/* <div className="py-10 flex flex-wrap gap-x-4 gap-y-6 items-start justify-start max-w-sm mx-auto"> */}
        <div className="cursor-pointer w-auto py-0 pr-2 ml-2 flex flex-wrap gap-x-4 gap-y-0  max-w-sm md:max-w-2xl mx-auto">
          {navlinks.map((link, idx) => (
          <div key={idx} className="relative z-40 flex  items-center justify-center" onClick={() => handleSelect(link)}>
          {/* <PlaneIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" /> */}
            {link.icon}
            <span key={idx + link.label} className={`text-neutral-700 dark:text-neutral-300 text-sm ${link.label === currentLink?.label ? activeCss : ''}`}>
              {link.label}
            </span>
          </div>
          ))}
          {medialinks.map((link, idx) => (
            <div key={idx} className="relative z-40 flex  items-center justify-center" onClick={() => handleSelect(link)}>
            {/* <PlaneIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" /> */}
              {link.icon}
              <span key={idx + link.label} className={`text-neutral-700 dark:text-neutral-300 text-sm ${link.label === currentLink?.label ? activeCss : ''}`}>
              {link.label}
              </span>
            </div>

              // <Item key={`LinkItem${idx}`} value={link.label} keywords={['issue', 'sprint']}
                // onSelect={()=>{ llog('onSelect:' + link.href.slice(1) );
                //   // setSpaceTag(link.href.slice(1));
                //   debounceSelect(link.href);
                // }}
              //   onMouseOver={()=>{
              //     debouncedMoauseOver(link.href);
              //   }} 
              // >
              //   <SidebarLinkNoHref key={idx} link={link} />
              // </Item>
            ))}

          {toollinks.map((link, idx) => (
          <div key={idx} className="relative z-40 flex  items-center justify-center" onClick={() => handleSelect(link)}>
          {/* <PlaneIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" /> */}
            {link.icon}
            <span key={idx + link.label} className={`text-neutral-700 dark:text-neutral-300 text-sm ${link.label === currentLink?.label ? activeCss : ''}`}>
              {link.label}
            </span>
          </div>
          ))}

          {/* <div className="relative z-40 flex items-center justify-center" onClick={() => setOpen(true)}>
            <ElevatorIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" />
            <span className="text-neutral-700 dark:text-neutral-300 text-sm">
              12 hotels
            </span>
          </div>
          <div className="relative z-40 flex items-center justify-center" onClick={() => setOpen(true)}>
            <VacationIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" />
            <span className="text-neutral-700 dark:text-neutral-300 text-sm">
              69 visiting spots
            </span>
          </div>
          <div className="relative z-40 flex  items-center justify-center" onClick={() => setOpen(true)}>
            <FoodIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" />
            <span className="text-neutral-700 dark:text-neutral-300 text-sm">
              Good food everyday
            </span>
          </div>
          <div className="relative z-40 flex items-center justify-center" onClick={() => setOpen(true)}>
            <MicIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" />
            <span className="text-neutral-700 dark:text-neutral-300 text-sm">
              Open Mic
            </span>
          </div>
          <div className="relative z-40 flex items-center justify-center" onClick={() => setOpen(true)}>
            <ParachuteIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" />
            <span className="text-neutral-700 dark:text-neutral-300 text-sm">
              Paragliding
            </span>
          </div> */}

        </div>
    </div>
    )
}

export const SideBarButtonsGroupMobile = ({onSelect, className }: {onSelect?: (link:any) => void; className?: string }) => {
  const [currentLink, setCurrentLink] = useState<NavLink>(DefaultNavLink);
  const handleSelect=(link:NavLink)=>{
    console.log('sidebar-handleSelect:' + link.href.slice(1) );
    console.log('sidebar-handleSelect: link', link );
    setCurrentLink(link);
    onSelect && onSelect(link);
  }

  // const activeCss = 'text-orange-500 border-border border-2 dark:text-orange-500 border-border border-2'
  const activeCss = 'text-orange-500 dark:text-orange-500 '

  return (
    <div className={className}>
        {/* <div className="py-10 flex flex-wrap gap-x-4 gap-y-6 items-start justify-start max-w-sm mx-auto"> */}
        <div className="cursor-pointer w-auto py-0 pr-2 ml-2 flex flex-wrap gap-x-4 gap-y-2  max-w-sm md:max-w-2xl mx-auto">
          {navlinks.map((link, idx) => (
          <div key={idx} className="relative z-40 flex items-center justify-center rounded-xl  bg-gradient-to-r from-backgroud-500/10 to-purple-500/10" onClick={() => handleSelect(link)}>
            {link.icon}
            <span key={idx + link.label} className={`text-neutral-700 dark:text-neutral-300 text-sm ${link.label === currentLink?.label ? activeCss : ''}`}>
              {link.label}
            </span>
          </div>
          ))}
          {medialinks.map((link, idx) => (
            <div key={idx} className="relative z-40 flex items-center justify-center rounded bg-gradient-to-r from-backgroud-500/10 to-purple-500/10" onClick={() => handleSelect(link)}>
            {/* <PlaneIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" /> */}
              {link.icon}
              <span key={idx + link.label} className={`text-neutral-700 dark:text-neutral-300 text-sm ${link.label === currentLink?.label ? activeCss : ''}`}>
              {link.label}
              </span>
            </div>
            ))}

          {toollinks.map((link, idx) => (
          <div key={idx} className="relative z-40 flex items-center justify-center rounded bg-gradient-to-r from-backgroud-500/10 to-purple-500/10 " onClick={() => handleSelect(link)}>
          {/* <PlaneIcon className="mr-1 text-neutral-700 dark:text-neutral-300 h-4 w-4" /> */}
            {link.icon}
            <span key={idx + link.label} className={`text-neutral-700 dark:text-neutral-300 text-sm ${link.label === currentLink?.label ? activeCss : ''}`}>
              {link.label}
            </span>
          </div>
          ))}
        </div>
    </div>
    )
}








